import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Activity } from '../entities/activity';
import { catchError, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { isPlatformBrowser } from '@angular/common';

interface ApiResponse {
  status: string;
  data: Activity | Activity[];
}

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private activityServiceUrl = this.apiServicesUrl + '/activity';

  postInteraction(activity: Activity): Observable<ApiResponse> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      })
    }
    return this.http.post<ApiResponse>(this.activityServiceUrl, activity, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponse>('getInteractions'))
    );
  }

  getInteractionsByPerson(filenames: string, url_id: string): Observable<ApiResponse> {
    let token;
    if (isPlatformBrowser(this.platformId))
      token = sessionStorage.getItem('auth');
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'bearer ' + token
      })
    }
    return this.http.post<ApiResponse>(this.activityServiceUrl + '-byurlid', {"filenames": filenames, "url_id": url_id}, httpHeaders)
    .pipe(
      catchError(this.handleError<ApiResponse>('getInteractions'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
